import React from 'react'
import '../../styles/services.css'

const serviceData = [
    {
        icon: 'ri-flight-takeoff-line',
        title: 'Technology gap',
        des: 'Challenges in detecting small objects moving in space , including cardboard drones, due to the lack of RF reflections'
    },
    {
        icon: 'ri-shield-user-line',
        title: 'Public safety',
        des: 'Due to the Ukraine-Russia war, terrorist groups worldwide are rapidly advancing tiny drones made from materials that do not reflect radar waves, as seen in the photos of this presentation'
    },
    {
        icon: 'ri-money-dollar-box-line',
        title: 'Costs',
        des: 'Existing defense-level solutions are incomplete, have limited capabilities, and are extremely costly'
    },
    {
        icon: 'ri-customer-service-2-fill',
        title: 'customer desire',
        des: 'Potential customers seek solutions that are easy to adopt, compact, portable, user-friendly, and highly reliable for addressing future threats'
    },
]


export default function Services() {
  return (
    <section id="service">
        <div className="container">
            <div className="service_top-content">
                {/* <h6 className="subtitle">(Enter title Here)</h6> */}
                <h2>Needs</h2>
                {/* <h2 className='highlight'>(enter subtitle here)</h2> */}
            </div>
            <div className="service_item-wrapper">
                {
                    serviceData.map((item, index) => (
                        <div className="services_item" key={index}>
                            <span className="service_icon"><i class={item.icon} /></span>
                            <h3 className="service_title">{item.title}</h3>
                            <p className="description">{item.des}</p>
                        </div>
                    ))
                }
            </div>
        </div>
    </section>
  )
}
